import { render, staticRenderFns } from "./CardUseSoil.vue?vue&type=template&id=63a85e97&scoped=true"
import script from "./CardUseSoil.vue?vue&type=script&lang=js"
export * from "./CardUseSoil.vue?vue&type=script&lang=js"
import style0 from "./CardUseSoil.vue?vue&type=style&index=0&id=63a85e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a85e97",
  null
  
)

export default component.exports